import { useSelector } from 'react-redux';

// Components
import ShiftStatus from '../../components/Dashboard/ShiftStatus/ShiftStatus';
import NextShiftModal from '../../components/Dashboard/NextShiftModal';
import AdminDrawer from '../../components/AdminDrawer/AdminDrawer';

// Redux actions & selectors
import { selectCurrentVenue, selectHasPrivilegedRole } from '../../redux/slices/currentUserSlice';
import { selectEmployeeShifts } from '../../redux/shifts/shiftsSlice';

// Hooks
import { useShiftModals } from '../../utils/Hooks/shifts/useShiftModals';
import { useDashboardData } from '../../utils/Hooks/dashboard/useDashboardData';
import { useDrawer } from '../../utils/Hooks/drawer/useDrawer';

// Styled components
import { DashboardContainer, MainContentContainer } from './Dashboard.styles';

// Drawer configuration
import { DRAWER_TYPES, DRAWER_CONFIG } from './dashboardDrawerConfig';

const Dashboard = () => {
  // Selectors
  const currentUser = useSelector((state) => state.currentUser);
  const { startOfWeekIndex, id: venueId } = useSelector(selectCurrentVenue) || {};
  const hasPrivilegedRole = useSelector(selectHasPrivilegedRole);
  const userShifts = useSelector(selectEmployeeShifts);

  // Derived values
  const employee = currentUser?.employeeInfo;

  // Data fetching hook
  useDashboardData(venueId, employee?.id, hasPrivilegedRole, startOfWeekIndex);

  // Modal state and handlers
  const { openNextShiftModal, selectedShift, handleOpenNextShiftModal, handleCloseNextShiftModal } = useShiftModals();

  // Drawer state and handlers
  const { isDrawerOpen, drawerType, drawerTitle, handleCloseDrawer, handleBackNavigation, renderDrawerContent } =
    useDrawer(
      {
        DRAWER_CONFIG,
      },
      DRAWER_TYPES.WEEKLY_SCHEDULE,
      true // Set drawer to be initially open
    );

  return (
    <DashboardContainer>
      <MainContentContainer className={isDrawerOpen ? 'drawer-open' : ''}>
        <ShiftStatus
          employeeName={employee?.displayName}
          employeeShifts={userShifts}
          onViewShift={handleOpenNextShiftModal}
          employeeId={employee?.id}
        />
      </MainContentContainer>

      <AdminDrawer
        isOpen={isDrawerOpen}
        onClose={handleCloseDrawer}
        onBack={DRAWER_CONFIG[drawerType]?.parent ? handleBackNavigation : undefined}
        showCloseButton={false}
        title={drawerTitle}
      >
        {renderDrawerContent()}
      </AdminDrawer>

      <NextShiftModal open={openNextShiftModal} onClose={handleCloseNextShiftModal} shift={selectedShift} />
    </DashboardContainer>
  );
};

export default Dashboard;
